import { createAction, props } from '@ngrx/store';
import { IUserLicense } from '../../../../interfaces/licenses/IUserLicense';

export const loadUserLicense = createAction('[User License] Load User License');

export const loadUserLicenseSuccess = createAction(
  '[User License] Load User License Success',
  props<{ userLicense: IUserLicense }>()
);

export const loadUserLicenseFailure = createAction(
  '[User License] Load User License Failure',
  props<{ error: any }>()
);
